export const CHAT_STATE = {
  EXPANDED: 0,
  COLLAPSED: 1,
  NORMAL: 2,
};
